import { Star, Quote } from "lucide-react";
import { testimonials } from "../../mock";

export default function TestimonialsSection() {
  return (
    <section
      className="relative py-24 lg:py-32 bg-cover bg-center"
      style={{
        backgroundImage:
          "linear-gradient(rgba(10,36,36,0.92), rgba(10,36,36,0.95)), url(/image/siteimages/gallery/restaurantPhotos/Photo%202.png)"
      }}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="divider-ornament text-spice-gold">Guest Stories</span>
          <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl font-medium mt-5 mb-4 leading-[1.1]">
            What Our <em className="italic text-spice-gold font-light">Guests Say</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-white/5 backdrop-blur border border-white/10 p-8 lg:p-10 relative"
            >
              <Quote className="text-spice-gold/40 absolute top-6 right-6" size={42} />
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={`${t.name}-star-${idx}`} size={14} className="text-spice-gold" fill="currentColor" />
                ))}
              </div>
              <p className="text-white/85 text-base leading-relaxed mb-6 font-light italic">
                “{t.text}”
              </p>
              <div className="pt-5 border-t border-white/10">
                <div className="font-display text-spice-gold text-lg">{t.name}</div>
                <div className="text-white/55 text-xs tracking-[0.2em] uppercase mt-0.5">
                  {t.location}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
